module.exports = __webpack_public_path__ + "static/media/Monopoly_D_HC.4ff88947.png";